import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default, { withTheme } from 'styled-components';
import themes from '../../theming/themes.js';
import React from 'react';
import _Box from '../Box/index.js';
import _Icon from '../Icon/index.js';
import { Link } from 'react-router-dom';
import { Heading } from '../../index.js';

var _excluded = ["children", "iconName", "theme", "color"],
  _excluded2 = ["heading", "secondaryHeading", "selectable", "selected", "cardLinks", "children", "small", "fontSize", "fontColor", "borderColor", "gradient", "elemType", "tabIndex", "theme"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
//FIXME: Border Gradient not perfect/ready yet - squares corners and applies to right border too, WIP
var CardBox = styled__default(_Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  ", "\n  \n  width: 100%;\n  box-sizing: border-box;\n  transition: all 0.3s ease;\n  box-shadow: 0px 1px 4px #0f1f2c40;\n  &:hover {\n    cursor: ", ";\n    box-shadow: ", ";\n  }\n  &:focus {\n    box-shadow: ", ";\n  }\n  width: 100%;\n\n"])), function (_ref) {
  var _theme$palette, _theme$palette2;
  var className = _ref.className,
    theme = _ref.theme;
  return (className === null || className === void 0 ? void 0 : className.includes('selected')) && "\n        border-color: ".concat(theme === null || theme === void 0 || (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.secondary, ";\n        outline: 1px solid  ").concat(theme === null || theme === void 0 || (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.secondary, "\n        box-shadow: 0 2px 6px ").concat(function (_ref2) {
    var _theme$palette3;
    var theme = _ref2.theme;
    return theme === null || theme === void 0 || (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.error;
  }, ";\n      ");
}, function (_ref3) {
  var _theme$palette4, _theme$palette5;
  var className = _ref3.className,
    theme = _ref3.theme;
  return (className === null || className === void 0 ? void 0 : className.includes('gradient')) && "border-image: linear-gradient(to bottom, ".concat(theme === null || theme === void 0 || (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.secondaryLight, ", ").concat(theme === null || theme === void 0 || (_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : _theme$palette5.gray, ") 1 100%;");
}, function (_ref4) {
  var className = _ref4.className;
  return (className === null || className === void 0 ? void 0 : className.includes('selectable')) && "pointer";
}, function (_ref5) {
  var _theme$palette6;
  var theme = _ref5.theme,
    className = _ref5.className;
  return (className === null || className === void 0 ? void 0 : className.includes('selectable')) && "0 2px 5px".concat(theme === null || theme === void 0 || (_theme$palette6 = theme.palette) === null || _theme$palette6 === void 0 ? void 0 : _theme$palette6.secondaryLight);
}, function (_ref6) {
  var _theme$palette7;
  var theme = _ref6.theme,
    className = _ref6.className;
  return (className === null || className === void 0 ? void 0 : className.includes('selectable')) && "0 2px 5px".concat(theme === null || theme === void 0 || (_theme$palette7 = theme.palette) === null || _theme$palette7 === void 0 ? void 0 : _theme$palette7.secondaryLight);
});
// Personally i think 1.15 rem is weirdly small for a heading element? - changed it so 1 is thinMode
var CardHeading = function CardHeading(props) {
  var style = {
    fontSize: props.fontSize === 'small' ? '1.15rem' : props.fontSize === 'medium' ? '1.325rem' : '1.625rem',
    width: '90%'
  };
  return /*#__PURE__*/React.createElement(Heading, _extends({
    color: props.fontColor ? props.fontColor : 'primaryDark',
    elemType: "h2",
    style: style
  }, props));
};
var CardIcon = styled__default(_Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  align-self: center;\n  text-decoration: none !important;\n"])), function (_ref7) {
  var _theme$palette$color, _theme$palette8, _theme$link$color, _theme$link;
  var color = _ref7.color,
    theme = _ref7.theme;
  return color ? (_theme$palette$color = theme === null || theme === void 0 || (_theme$palette8 = theme.palette) === null || _theme$palette8 === void 0 ? void 0 : _theme$palette8[color]) !== null && _theme$palette$color !== void 0 ? _theme$palette$color : themes["default"].palette[color] : (_theme$link$color = theme === null || theme === void 0 || (_theme$link = theme.link) === null || _theme$link === void 0 ? void 0 : _theme$link.color) !== null && _theme$link$color !== void 0 ? _theme$link$color : themes["default"].link.color;
});
//all but display and gap come from regular honest Link
//will apply underline to embedded icons, use CardLinkWithIcon to avoid that
// got rid of our default Link text shadow and transition as it was uggo
var CardLink = styled__default(Link)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  text-align: left;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n  display: flex;\n  gap: .25rem;\n"])), function (_ref8) {
  var _theme$palette$color2, _theme$palette9, _theme$link$color2, _theme$link2;
  var color = _ref8.color,
    theme = _ref8.theme;
  return color ? (_theme$palette$color2 = theme === null || theme === void 0 || (_theme$palette9 = theme.palette) === null || _theme$palette9 === void 0 ? void 0 : _theme$palette9[color]) !== null && _theme$palette$color2 !== void 0 ? _theme$palette$color2 : themes["default"].palette[color] : (_theme$link$color2 = theme === null || theme === void 0 || (_theme$link2 = theme.link) === null || _theme$link2 === void 0 ? void 0 : _theme$link2.color) !== null && _theme$link$color2 !== void 0 ? _theme$link$color2 : themes["default"].link.color;
});
var StyledCardLink = styled__default(Link)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none !important;\n  text-align: left;\n  display: flex;\n  gap: .25rem;\n"])), function (_ref9) {
  var color = _ref9.color,
    _ref9$theme = _ref9.theme,
    theme = _ref9$theme === void 0 ? themes["default"] : _ref9$theme;
  return !!color ? theme.palette[color] : theme.link.color;
});
var StyledLinkSpan = styled__default('span')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n    transition: text-decoration 0.25s;\n  }\n"])));
var CardLinkWithIcon = function CardLinkWithIcon(_ref10) {
  var children = _ref10.children,
    iconName = _ref10.iconName,
    _ref10$theme = _ref10.theme,
    theme = _ref10$theme === void 0 ? themes["default"] : _ref10$theme,
    color = _ref10.color,
    rest = _objectWithoutProperties(_ref10, _excluded);
  return /*#__PURE__*/React.createElement(StyledCardLink, _extends({
    theme: theme
  }, rest), iconName && /*#__PURE__*/React.createElement(CardIcon, {
    theme: theme,
    name: iconName,
    color: color
  }), /*#__PURE__*/React.createElement(StyledLinkSpan, {
    theme: theme,
    color: color
  }, children));
};
var CardLinkContainer = styled__default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  row-gap: .75rem;\n  column-gap: 1.5rem;\n  flex-wrap: wrap;\n"])));
var Card = function Card(_ref11) {
  var heading = _ref11.heading,
    secondaryHeading = _ref11.secondaryHeading,
    selectable = _ref11.selectable,
    selected = _ref11.selected,
    cardLinks = _ref11.cardLinks,
    children = _ref11.children,
    small = _ref11.small,
    fontSize = _ref11.fontSize,
    fontColor = _ref11.fontColor,
    _ref11$borderColor = _ref11.borderColor,
    borderColor = _ref11$borderColor === void 0 ? 'primaryDark' : _ref11$borderColor,
    gradient = _ref11.gradient,
    _ref11$elemType = _ref11.elemType,
    elemType = _ref11$elemType === void 0 ? 'h2' : _ref11$elemType,
    tabIndex = _ref11.tabIndex,
    _ref11$theme = _ref11.theme,
    theme = _ref11$theme === void 0 ? themes["default"] : _ref11$theme,
    rest = _objectWithoutProperties(_ref11, _excluded2);
  return /*#__PURE__*/React.createElement(CardBox, _extends({
    tabIndex: tabIndex,
    borderType: "rounded",
    style: {
      borderLeft: borderColor !== 'none' ? ".5rem solid ".concat(gradient ? 'transparent' : theme === null || theme === void 0 ? void 0 : theme.palette[borderColor]) : ''
    },
    className: "".concat(selectable ? 'selectable' : '', " ").concat(selected ? 'selected' : '', " ").concat(gradient ? 'gradient' : '')
  }, rest), heading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(CardHeading, {
    fontSize: fontSize,
    fontColor: fontColor,
    elemType: elemType,
    small: small
  }, heading), secondaryHeading && /*#__PURE__*/React.createElement("div", {
    className: 'mt-0'
  }, secondaryHeading)), /*#__PURE__*/React.createElement("hr", {
    className: 'mt-2 mb-3'
  })), children, cardLinks && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: 'mt-3 mb-2'
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-2",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, cardLinks)));
};
var index = withTheme(Card);

export default index;
export { CardIcon, CardLink, CardLinkContainer, CardLinkWithIcon };
